<template>
    <div class="margin-bottom-10 comp-search-bar">
        <!--<Tag type="dot" closable color="primary" v-for="(label, key) in search" :key="key">-->
            <!--{{label.label}}：-->
        <!--</Tag>-->
        <span v-for="(label, key) in search" clsss="checker-box" :key="key">
            <span v-if="label.selected.length && label.values.length" class="checker-out">
                <span class="checker-label">{{label.label}}：</span>
                <Tag v-for="(select, index_s) in label.selected" :key="select" color="primary"
                     closable
                     @on-close="label.selected.splice(index_s, 1)"
                     class="checker-in">
                    <span>{{label.values[select].name}}</span>
                    <!--<span class="close" @click="label.selected.splice(index_s, 1)"><Icon type="md-close" /></span>-->
                </Tag>
            </span>
        </span>
        <!--隐藏调用，search内容变化时可触发计算，利用此进行remote查询操作-->
        <!--<span v-show="false">{{searchText.toString()}}</span>-->
    </div>
</template>

<script>
    export default {
        name: "search-bar",
        props: {
            search: Object
        },
        data () {
            return {
                staticSearch: ''
            }
        },
        watch: {
            search: {
                handler (newSearch) {
                    let values = [];
                    for(let k in newSearch) {
                        values.push(newSearch[k].selected)
                    }
                    let newStatic = values.join('-');
                    let value = values.find(elem=>{
                       return elem.length;
                    })
                    // 首次不触发loadData，
                    if (value) {
                        this.$emit('on-search');
                        this.staticSearch = newStatic;
                    }else{ // 不是第一次的判断，取消
                        if (this.staticSearch){
                            this.staticSearch = '';
                            this.$emit('on-search');
                        }
                    }
                },
                deep: true,
                immediate: false
            }
        }
    }
</script>

<style scoped lang="less">

    .checker-box{
        display: inline-block;
    }
    .checker-out {
        /*background-color: #3498db;*/
        padding: 4px 5px;
        margin-right: 10px;
        overflow: hidden;
        cursor: pointer;
    }
    .checker-out:hover{
        border: 1px solid #3498db;
    }
    .checker-label{
        font-size: 16px;
        font-weight: 600;
    }
    .checker-in {
        border-radius: 2px;
        margin-bottom: 4px;
    }
    .close {
        cursor: pointer;
        padding: 0 2px;
        display: inline-block;
        height: 100%;
    }
    .close:hover{
        background-color: red;
        color: white;
    }
    .name {
        padding: 0 5px;
        font-size: 0.8em;
    }
</style>